import Routes from '../constants/routes';
import { SCHOOL_TYPES } from '../constants/school-types';
import { world } from '../languages';
import { SchoolMenuFilter } from '../services/school/header-school-menu';
import store from '../store';

type LandingCategoryType =
    | SchoolMenuFilter
    | {
          id: number;
          slug: string;
      };

type LandingLinkPropsType = {
    category?: LandingCategoryType;
    type?: string;
};

export const landingLink = ({ type, category }: LandingLinkPropsType) => {
    const id = category?.id;
    const extraFilters = {
        [SCHOOL_TYPES.PRIMARY_SCHOOL]: {
            de: '1,2,3,4',
            es: '26,29,32,35,38,41,44',
            fr: '226,220,223,205,166,169,172,175,178,229,232'
        },
        [SCHOOL_TYPES.SECONDARY_SCHOOL]: {
            de: '5,6,7,8,9,10,11,12,13',
            es: '47,50,59,62',
            fr: '181,184,187,190,232,235,196,193,199,238,241,202,208,214,211,217'
        }
    };
    let url;
    const { isActiveNavigationAbTest } = store.getState().main.schoolClassification;
    const isSharedLinkToSchool = window.location.pathname.startsWith(Routes.SCHOOL_LANDING_PAGES.prefix);

    if (!isActiveNavigationAbTest && !isSharedLinkToSchool) {
        if (category?.slug) {
            if (type) {
                url = `${Routes.LANDING.prefix}/${id}/${category.slug}?c=${extraFilters[type][world]}`;
            } else {
                url = `${Routes.LANDING.prefix}/${id}/${category.slug}`;
            }
        } else if (type) {
            url = `${Routes.SEARCH_RESULT.path}?query=&t=${id}&c=${extraFilters[type][world]}`;
        } else {
            url = `${Routes.SEARCH_RESULT.path}?query=&t=${id}`;
        }

        return url;
    }

    const grades = store
        .getState()
        .main.schoolClassification.schools.reduce((acc, school) => ({ ...acc, [school.type]: school.grades }), {});
    const idQuery = id ? `&t=${id}` : '';
    let gradesQuery = type ? `&c=${grades[type]}` : '';

    if (id) {
        if (!type) {
            url = `${Routes.SEARCH_RESULT.path}/?query=${idQuery}${gradesQuery}`;
        } else {
            gradesQuery = `?${gradesQuery.slice(1)}`;

            url = `${Routes.SCHOOL_LANDING_PAGES.prefix}/${type}/${id}${gradesQuery}`;
        }
    } else if (type) {
        url = `${Routes.SCHOOL_LANDING_PAGES.prefix}/${type}?query=${idQuery}${gradesQuery}`;
    } else {
        url = `${Routes.SEARCH_RESULT.path}?query=${idQuery}${gradesQuery}`;
    }

    return url;
};
